import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = checking, false = guest, obj = admin
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("ap_token");
    if (!token) {
      setAdmin(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => {
        localStorage.removeItem("ap_token");
        setAdmin(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = useCallback(async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("ap_token", data.access_token);
      setAdmin({ email: data.email, role: data.role });
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("ap_token");
    setAdmin(false);
  }, []);

  return (
    <AuthContext.Provider value={{ admin, isAdmin: !!admin, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
